export default function Alert({ children, className, color }) {
  let colorClassName = "bg-red-50 text-red-300 border border-red-100";
  if (color === "yellow") {
    colorClassName = "bg-yellow-50 text-black-200 border border-yellow-100";
  }
  if (color === "primary") {
    colorClassName = "bg-primary-50 text-primary-700 border border-primary-200";
  }
  if (color === "green") {
    colorClassName = "bg-green-50 text-green-300 border border-green-100";
  }
  return (
    <div
      className={
        "p-3 rounded-sm text-sm font-medium " + colorClassName + " " + className
      }
    >
      {children}
    </div>
  );
}
